"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IMAGE_LAYOUT = exports.BUTTON_KIND = exports.BACKGROUND_COLOR_TYPE = void 0;
var _button = require("../button");
/*
Copyright (c) Uber Technologies, Inc.

This source code is licensed under the MIT license found in the
LICENSE file in the root directory of this source tree.
*/

const BACKGROUND_COLOR_TYPE = exports.BACKGROUND_COLOR_TYPE = Object.freeze({
  light: 'light',
  dark: 'dark'
});
const IMAGE_LAYOUT = exports.IMAGE_LAYOUT = Object.freeze({
  top: 'top',
  trailing: 'trailing'
});
const BUTTON_KIND = exports.BUTTON_KIND = Object.freeze({
  [_button.KIND.secondary]: _button.KIND.secondary,
  [_button.KIND.tertiary]: _button.KIND.tertiary
});